import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

// Catch-all route: trabadju.cv/<codigo> → /?ref=<codigo> when it is an approved influencer link; otherwise home.
export const AffiliateRedirect = () => {
  const { pathname } = useLocation();
  const [target, setTarget] = useState(null);
  useEffect(() => {
    const code = pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
    if (!code || code.includes('/') || !/^[a-z0-9_-]{2,32}$/.test(code)) { setTarget('/'); return; }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/influencers/link/${code}`)
      .then(({ data }) => setTarget(`/?ref=${encodeURIComponent(data.code)}`))
      .catch(() => setTarget('/'));
  }, [pathname]);
  if (!target) return null;
  return <Navigate to={target} replace />;
};
